export const t24 = [
    {
      id: 0,
      name: "YOGGI HARSHA",
      position: "PRESIDENT",
      alt: "YOGGI HARSHA",
      image: "Team/t24/yoggi.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/yoggi-harsha-5bb2a61b6/?locale=es_ES",
        github: '',
        instagram:'',
      },
      
    },
    {
      id: 1,
      name: "SRESHTA",
      position: "VICE PRESIDENT",
      alt: "SRESHTA",
      image: "Team/t24/shreshta.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/sreshtamannam0202/",
        github: 'https://github.com/SreshtaMannam',
        instagram:'',
      },
      
    },
    {
      id: 2,
      name: "SIDDHARTH",
      position: "TECHNICAL",
      alt: "SIDDHARTH",
      image: "Team/t24/dp.jpeg",
      socials: {
        linkedin: "https://www.linkedin.com/in/siddharth-kanna-823bb5219",
        github: 'https://github.com/siddharthkanna',
        instagram:'https://www.instagram.com/siddharth__kanna',
      },
      
    },
    {
      id: 3,
      name: "ADITYA RAM",
      position: "TECHNICAL",
      alt: "ADITYA RAM",
      image: "Team/t24/adityaa.png",
      socials: {
        linkedin: "https://www.linkedin.com/in/v-aditya-ram-645878215/?originalSubdomain=in",
        github: 'https://github.com/Aditya123-adi',
        instagram:'https://instagram.com/aditya_ram_15?igshid=ZDdkNTZiNTM=',
      },
    
    },
    {
      id: 4,
      name: "VENKAT GANESH",
      position: "MEDIA",
      alt: "VENKAT GANESH",
      image: "Team/t24/ganesh.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/ganesh-kallagunta-873891204/",
        github: '',
        instagram:'',
      },
    },
    {
      id: 5,
      name: "BHARATH REDDY",
      position: "MEDIA",
      alt: "BHARATH",
      image: "Team/t24/BHARAT.jpg",
      socials: {
        linkedin: "",
        github: '',
        instagram:'',
      },
    },
    {
      id: 6,
      name: "SPANDANA",
      position: "PROMOTIONS",
      alt: "SPANDANA",
      image: "Team/t24/spandana.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/spandana-reddy-595a36236/?originalSubdomain=in",
        github: '',
        instagram:'',
      },
    },
    {
      id: 7,
      name: "LOHITH",
      position: "PROMOTIONS",
      alt: "LOHITH",
      image: "Team/t24/IMG_0220-1.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/lohith-palasa-266262237/?trk=public_profile_browsemap&originalSubdomain=in",
        github: '',
        instagram:'',
      },
    },
    {
      id: 8,
      name: "RITHVIKA",
      position: "LEGALS",
      alt: "RITHVIKA",
      image: "Team/t24/rithvika.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/lakshmi-rithvika-b1025a237/?originalSubdomain=in",
        github: '',
        instagram:'',
      },
    },
    {
      id: 9,
      name: "RAJENDRA",
      position: "EXTERNAL AFFAIRS",
      alt: "RAJENDRA",
      image: "Team/t24/KONDAPAMULA-RAJENDRA.webp",
      socials: {
        linkedin: "https://www.linkedin.com/in/rajendra-k-850493204/",
        github: '',
        instagram:'',
      },
  
    },
    
    {
      id: 10,
      name: "AISHWARYA",
      position: "HOSPITALITY",
      alt: "AISHWARYA",
      image: "Team/t24/aishwarya.webp",
      socials: {
        linkedin: "",
        github: '',
        instagram:'https://www.instagram.com/_aishu002',
      },
    },
    
    {
      id: 11,
      name: "varun shanagapati",
      position: "TECHNICAL",
      alt: "varun shanagapati",
      image: "Team/t24/varun.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/varun-shanagapati-697b691b9/?originalSubdomain=in",
        github: 'https://github.com/varunshanagapati',
        instagram:'',
      },
    },
    {
      id: 12,
      name: "PREMCHAND",
      position: "TECHNICAL",
      alt: "PREMCHAND",
      image: "Team/t24/prem.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/ch-premchand/",
        github: 'https://github.com/ch-premchand',
        instagram:'',
      },
    },
    {
      id: 13,
      name: "Rahul Konda",
      position: "Graphic Designer",
      alt: "Rahul",
      image: "Team/t24/KONDA RAHUL.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/rahul-konda-7416b3225",
        github: '',
        instagram:'',
      },
    },
    {
      id: 14,
      name: "Divya",
      position: "Hospitality",
      alt: "Divya",
      image: "Team/t24/DIVYA.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/rahul-konda-7416b3225",
        github: '',
        instagram:'',
      },
    },
    {
      id: 15,
      name: "Samhitha",
      position: "Hospitality",
      alt: "Samhitha",
      image: "Team/t24/SAMHITHA.jpg",
      socials: {
        linkedin: "https://www.linkedin.com/in/rahul-konda-7416b3225",
        github: '',
        instagram:'',
      },
    },
  ];
  
  
  